// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Button,
//   TextField,
//   CircularProgress,
//   Alert,
// } from "@mui/material";
// import Particles from "react-tsparticles";
// import { loadFull } from "tsparticles";
// import axios from "axios";

// // Add API_BASE
// const API_BASE = process.env.REACT_APP_API_URL;

// function UserProfile({ userId }) {
//   const token = localStorage.getItem("token");
//   const [user, setUser] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [editUsername, setEditUsername] = useState("");
//   const [editStatus, setEditStatus] = useState("");
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);
//   const [loadingUser, setLoadingUser] = useState(true);

//   // Particle background init using dark color like other pages
//   const particlesInit = useCallback(async (engine) => {
//     await loadFull(engine);
//   }, []);

//   // Dark particles config to match other pages (not white bg)
//   const particlesOptions = {
//     fullScreen: { enable: false },
//     fpsLimit: 60,
//     background: { color: "#191931" },
//     particles: {
//       number: { value: 80, density: { enable: true, area: 900 } },
//       color: { value: ["#6b7afd", "#62d6e8", "#ffd166"] },
//       shape: { type: "circle" },
//       opacity: { value: 0.65, random: true },
//       size: { value: 3.5, random: true },
//       move: { enable: true, speed: 1.5, outModes: "bounce" },
//       links: {
//         enable: true,
//         distance: 130,
//         color: "#8b8de8",
//         opacity: 0.15,
//         width: 2,
//       },
//     },
//     detectRetina: true,
//   };

//   // Fetch user data on mount or userId change
//   useEffect(() => {
//     let mounted = true;
//     async function fetchUser() {
//       setLoadingUser(true);
//       setError(null);
//       try {
//         const res = await  axios.get(`${API_BASE}/api/users/${userId}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         if (mounted) {
//           setUser(res.data);
//           setEditUsername(res.data.username || "");
//           setEditStatus(res.data.status || "");
//         }
//       } catch (err) {
//         if (mounted) setError("Failed to load user data.");
//       } finally {
//         if (mounted) setLoadingUser(false);
//       }
//     }
//     if (userId) fetchUser();
//     return () => {
//       mounted = false;
//     };
//   }, [userId, token]);

//   // Handle profile photo upload with detailed error logging
//   const handleProfilePhotoChange = async (e) => {
//     if (!e.target.files[0]) return;
//     const file = e.target.files[0];
//     const formData = new FormData();
//     formData.append("file", file);

//     setUploading(true);
//     setError(null);

//     try {
//       const res = await  axios.post(`${API_BASE}/api/upload`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const updatedUser = await axios.patch(
//         `${API_BASE}/api/users/${userId}`,
//         { profilePhoto: res.data.fileUrl },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setUser(updatedUser.data);
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//         err.message ||
//         "Profile photo upload failed. Check backend and logs."
//       );
//       console.error("Upload error:", err);
//     } finally {
//       setUploading(false);
//     }
//   };

//   // Save username & status updates
//   const handleProfileSave = async () => {
//     if (!editUsername.trim()) {
//       setError("Username cannot be empty.");
//       return;
//     }

//     setSaving(true);
//     setError(null);
//     try {
//       const updatedUser = await axios.patch(
//         `${API_BASE}/api/users/${userId}`,
//         { username: editUsername.trim(), status: editStatus.trim() },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setUser(updatedUser.data);
//       alert("Profile updated successfully!");
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//         err.message ||
//         "Profile update failed. Please try again."
//       );
//       console.error("Profile update error:", err);
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Box sx={{ position: "relative", minHeight: "100vh", overflow: "hidden" }}>
//       <Particles
//         id="tsparticles"
//         init={particlesInit}
//         options={particlesOptions}
//         style={{
//           position: "fixed",
//           width: "100%",
//           height: "100%",
//           top: 0,
//           left: 0,
//           zIndex: 0,
//         }}
//       />
//       <Box
//         sx={{
//           maxWidth: 450,
//           mx: "auto",
//           mt: 8,
//           p: 4,
//           borderRadius: 4,
//           bgcolor: "#212140",
//           color: "#fff",
//           textAlign: "center",
//           boxShadow: "0 0 35px #7459f7cc",
//           position: "relative",
//           zIndex: 2,
//         }}
//       >
//         <Typography variant="h4" gutterBottom>
//           Profile
//         </Typography>

//         {error && (
//           <Alert severity="error" sx={{ mb: 3 }}>
//             {error}
//           </Alert>
//         )}

//         {loadingUser ? (
//           <CircularProgress />
//         ) : (
//           <>
//             <Box sx={{ mb: 3 }}>
//               <Avatar
//                 src={user?.profilePhoto ? `${API_BASE}${user.profilePhoto}` : ""}
//                 sx={{
//                   width: 120,
//                   height: 120,
//                   fontSize: 48,
//                   bgcolor: "#746bfd",
//                   mx: "auto",
//                   mb: 1,
//                   border: "3px solid #ffc85785",
//                 }}
//               >
//                 {!user?.profilePhoto && (user?.username ? user.username[0].toUpperCase() : "?")}
//               </Avatar>
//               <Button
//                 variant="contained"
//                 component="label"
//                 disabled={uploading}
//                 sx={{
//                   bgcolor: "#7b59f7",
//                   "&:hover": { bgcolor: "#9f7cff" },
//                   fontWeight: 700,
//                   px: 4,
//                   py: 1.2,
//                   mt: 1,
//                 }}
//               >
//                 {uploading ? <CircularProgress size={25} color="inherit" /> : "Upload Profile Photo"}
//                 <input
//                   type="file"
//                   hidden
//                   accept="image/*"
//                   onChange={handleProfilePhotoChange}
//                 />
//               </Button>
//             </Box>

//             <TextField
//               label="Username"
//               value={editUsername}
//               onChange={(e) => setEditUsername(e.target.value)}
//               fullWidth
//               autoFocus
//               disabled={saving}
//               sx={{
//                 mb: 3,
//                 bgcolor: "#252355",
//                 input: { color: "#fff" },
//                 label: { color: "#b4bdea" },
//                 borderRadius: 2,
//               }}
//             />

//             <TextField
//               label="Status"
//               value={editStatus}
//               onChange={(e) => setEditStatus(e.target.value)}
//               fullWidth
//               disabled={saving}
//               sx={{
//                 mb: 4,
//                 bgcolor: "#252355",
//                 input: { color: "#fff" },
//                 label: { color: "#b4bdea" },
//                 borderRadius: 2,
//               }}
//             />

//             <Button
//               variant="contained"
//               color="primary"
//               disabled={saving || !editUsername.trim()}
//               onClick={handleProfileSave}
//               sx={{
//                 fontWeight: 700,
//                 py: 1.3,
//                 px: 6,
//                 borderRadius: 3,
//                 boxShadow: "0 0 12px #5ad4fb",
//                 "&:hover": { bgcolor: "#3ac1fb" },
//               }}
//             >
//               {saving ? <CircularProgress size={26} color="inherit" /> : "Save Profile"}
//             </Button>
//           </>
//         )}
//       </Box>
//     </Box>
//   );
// }

// export default UserProfile;


import React, { useState, useEffect } from "react";
import {
  Box, Typography, Avatar, Button, TextField, CircularProgress, Alert,
} from "@mui/material";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

function UserProfile({ userId }) {
  const token = localStorage.getItem("token");
  const [user, setUser] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [editUsername, setEditUsername] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    let mounted = true;
    if (!userId) return;
    setLoadingUser(true);
    axios.get(`${API_BASE}/api/users/${userId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        if (!mounted) return;
        setUser(res.data);
        setEditUsername(res.data.username || "");
        setEditStatus(res.data.status || "");
      })
      .catch(() => { if (mounted) setError("Failed to load user data."); })
      .finally(() => { if (mounted) setLoadingUser(false); });
    return () => { mounted = false; };
  }, [userId, token]);

  const handlePhotoChange = async (e) => {
    if (!e.target.files[0]) return;
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    setUploading(true); setError(null);
    try {
      const res = await axios.post(`${API_BASE}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
      });
      const updated = await axios.patch(
        `${API_BASE}/api/users/${userId}`,
        { profilePhoto: res.data.fileUrl },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setUser(updated.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Upload failed.");
    } finally {
      setUploading(false);
    }
  };

  const handleSave = async () => {
    if (!editUsername.trim()) { setError("Username cannot be empty."); return; }
    setSaving(true); setError(null); setSuccess(false);
    try {
      const updated = await axios.patch(
        `${API_BASE}/api/users/${userId}`,
        { username: editUsername.trim(), status: editStatus.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setUser(updated.data);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Update failed.");
    } finally {
      setSaving(false);
    }
  };

  const inputSx = {
    '& .MuiFilledInput-root': {
      bgcolor: '#141B22', borderRadius: '10px', border: '1px solid #1A2228',
      '&:hover': { bgcolor: '#111820', borderColor: '#253035' },
      '&.Mui-focused': { bgcolor: '#111820', borderColor: '#00C2B3' },
      '&::before, &::after': { display: 'none' },
    },
    '& .MuiFilledInput-input': { color: '#F0F4F8', fontFamily: "'Outfit', sans-serif", fontSize: 15, py: 1.5 },
    '& .MuiInputLabel-root': { color: '#3A4A58', fontFamily: "'Outfit', sans-serif", '&.Mui-focused': { color: '#00C2B3' } },
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#090C0F', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', p: 4 }}>
      <Box sx={{ width: '100%', maxWidth: 520 }}>
        {/* Header */}
        <Typography sx={{
          fontFamily: "'Outfit', sans-serif", fontWeight: 700,
          fontSize: 26, color: '#F0F4F8', letterSpacing: '-0.02em', mb: 0.5,
        }}>
          Profile
        </Typography>
        <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#3A4A58', mb: 4 }}>
          Manage your account information
        </Typography>

        {error && (
          <Alert severity="error" sx={{
            mb: 3, bgcolor: '#1A0E0E', color: '#FF6B6B',
            border: '1px solid #2A1515', borderRadius: '10px',
            fontFamily: "'Outfit', sans-serif",
            '& .MuiAlert-icon': { color: '#FF6B6B' },
          }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{
            mb: 3, bgcolor: '#0A2018', color: '#00C2B3',
            border: '1px solid #0A3530', borderRadius: '10px',
            fontFamily: "'Outfit', sans-serif",
            '& .MuiAlert-icon': { color: '#00C2B3' },
          }}>
            Profile updated successfully!
          </Alert>
        )}

        {loadingUser ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress sx={{ color: '#00C2B3' }} />
          </Box>
        ) : (
          <>
            {/* Avatar section */}
            <Box sx={{
              bgcolor: '#0E1318', border: '1px solid #1A2228',
              borderRadius: '16px', p: 3, mb: 2,
              display: 'flex', alignItems: 'center', gap: 3,
            }}>
              <Box sx={{ position: 'relative' }}>
                <Avatar
                  src={user?.profilePhoto ? `${API_BASE}${user.profilePhoto}` : ""}
                  sx={{
                    width: 80, height: 80, fontSize: 28, fontWeight: 700,
                    bgcolor: '#00C2B3', color: '#090C0F',
                  }}
                >
                  {!user?.profilePhoto && (user?.username?.[0]?.toUpperCase() || "?")}
                </Avatar>
                {uploading && (
                  <Box sx={{
                    position: 'absolute', inset: 0, borderRadius: '50%',
                    bgcolor: 'rgba(9,12,15,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <CircularProgress size={24} sx={{ color: '#00C2B3' }} />
                  </Box>
                )}
              </Box>
              <Box>
                <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 18, color: '#F0F4F8', mb: 0.5 }}>
                  {user?.username || 'User'}
                </Typography>
                <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#3A4A58', mb: 1.5 }}>
                  {user?.email}
                </Typography>
                <Button
                  component="label"
                  disabled={uploading}
                  sx={{
                    fontFamily: "'Outfit', sans-serif", fontWeight: 500, fontSize: 12,
                    textTransform: 'none', py: 0.7, px: 2,
                    bgcolor: '#141B22', color: '#A0B0BF',
                    border: '1px solid #1A2228', borderRadius: '8px',
                    '&:hover': { bgcolor: '#1A2530', borderColor: '#253035', color: '#F0F4F8' },
                  }}
                >
                  Change photo
                  <input type="file" hidden accept="image/*" onChange={handlePhotoChange} />
                </Button>
              </Box>
            </Box>

            {/* Edit form */}
            <Box sx={{
              bgcolor: '#0E1318', border: '1px solid #1A2228',
              borderRadius: '16px', p: 3,
            }}>
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 14, color: '#A0B0BF', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 2.5 }}>
                Account details
              </Typography>

              <TextField
                label="Username" value={editUsername}
                onChange={e => setEditUsername(e.target.value)}
                fullWidth disabled={saving} variant="filled"
                sx={{ ...inputSx, mb: 2 }}
              />

              <TextField
                label="Status" value={editStatus}
                onChange={e => setEditStatus(e.target.value)}
                fullWidth disabled={saving} variant="filled"
                placeholder="What's on your mind?"
                sx={{ ...inputSx, mb: 3 }}
              />

              <Button
                fullWidth onClick={handleSave}
                disabled={saving || !editUsername.trim()}
                sx={{
                  py: 1.5, bgcolor: '#00C2B3', color: '#090C0F',
                  fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 15,
                  borderRadius: '10px', textTransform: 'none',
                  '&:hover': { bgcolor: '#00D5C5' },
                  '&.Mui-disabled': { bgcolor: '#0A3530', color: '#004A44' },
                }}
              >
                {saving ? <CircularProgress size={22} sx={{ color: '#004A44' }} /> : 'Save changes'}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}

export default UserProfile;